export enum EmployerFundTopUpStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  UNSUPPORTED_PAYMENT_METHOD = "UNSUPPORTED_PAYMENT_METHOD"
}
